var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BasePopup',_vm._g({staticClass:"user-select-popup"},_vm.$listeners),[_c('UserSelectTile',_vm._g(_vm._b({staticClass:"user-select-popup__content",attrs:{"inPopup":""}},'UserSelectTile',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }